import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs';

/**
 * Single source of truth for responsive layout decisions.
 * Replaces the old orientation-based `ScreenUtils.isLandscape()` checks with
 * width-based breakpoints. SSR-safe (BreakpointObserver no-ops on the server
 * and defaults to the desktop layout).
 */
@Injectable({ providedIn: 'root' })
export class LayoutService {
  private readonly bp = inject(BreakpointObserver);

  /** < 1024px: stacked layout, bottom mini-player. */
  readonly isCompact = toSignal(
    this.bp.observe('(max-width: 1023.98px)').pipe(map((s) => s.matches)),
    { initialValue: false },
  );

  /** < 640px: phone layout, collapsed search + overflow nav. */
  readonly isHandset = toSignal(
    this.bp.observe('(max-width: 639.98px)').pipe(map((s) => s.matches)),
    { initialValue: false },
  );
}
